import { IVideoCardList } from '../discovery/interface';
import paths from '../paths';
import { axiosAdaptiveHubClient } from './axiosAdaptiveHubClient';

export const getContinueWatchListAPI = async (payload): Promise<IVideoCardList> => {
  try {
    const response = await axiosAdaptiveHubClient.get<IVideoCardList>(
      paths.getContinueWatchList(payload)
    );
    return response.data;
  } catch (e) {
    console.log('error getContinueWatchListAPI ', e);
    throw e;
  }
};
